import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { AngularFireStorage, AngularFireUploadTask } from "angularfire2/storage";
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Camera } from "@ionic-native/camera";
import { Platform, ActionSheetController, LoadingController, AlertController } from "ionic-angular";
import { ImageProvider } from "../../providers/image/image";
import { Observable } from 'rxjs/Observable';
import { _, ComponentResolver } from "ag-grid-community";
import * as jsPDF from 'jspdf';
import { AppConfig } from "../../providers/config";
import { PRESCRIPTION_IMAGE } from "../../providers/images";

@Component({
  selector: "upload-prescription",
  templateUrl: "upload-prescription.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadPrescriptionComponent {
  @Input() existingImageUrl: any;
  @Input() existingImageType: any;
  @Input() clinic_name: any;
  @Input() doctor: any = {};
  @Input() patient: any = {};
  @Output() getPrescriptionUrl = new EventEmitter<Object>();

  task: AngularFireUploadTask;

  progress: any; // Observable 0 to 100
  complete: any;
  ismobile: boolean;
  imageUrl: string; // base64
  pdfUrl: string;
  downloadUrl: string;
  image_type: string = 'prescription';

  snapshot: Observable<any>;
  isHovering: boolean;

  public mobileimages = [];

  constructor(
    public storage: AngularFireStorage,
    public camera: Camera,
    private platform: Platform,
    private iab: InAppBrowser,
    private actionSheetCtrl: ActionSheetController,
    private image: ImageProvider,
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (this.platform.is("ios") || this.platform.is("android")) {
      this.ismobile = true;
    }

    if(this.existingImageType === 'pdf')  {
      if(this.existingImageUrl) this.pdfUrl = this.existingImageUrl;
    }
    else {
      if(this.existingImageUrl) this.imageUrl = this.existingImageUrl;
    }    
  }
  
  async captureImage(sourceType) {
      const options = {
        quality: 50,
        encodingType: 0,
        destinationType: 0,
        targetWidth: 1024,
        targetHeight: 1024,
        correctOrientation: true,
        allowEdit: false,
        sourceType: sourceType
      };
      return await this.camera.getPicture(options)
      .then((image) => {
        return image;
      })
      .catch((error) => {
        return null;
      })
  }

  createUploadTask(file: string, type: string): void {
    const loading = this.loadingCtrl.create({});
    loading.present();

    let filePath: any = null;
    filePath = `${this.image_type}/${this.clinic_name}_${this.doctor.last_name}_${new Date().getTime()}.${type}`;

    console.log("File Path: ", filePath);
    this.task = this.storage.ref(filePath).putString(file, "data_url")
  
    this.task.then((t) => {
      t.ref.getDownloadURL().then((u) => {
        this.downloadUrl = u;
        if(type === 'pdf')  {
          this.pdfUrl = this.downloadUrl;
          this.imageUrl = null;
        }
        else {
          this.pdfUrl = null;
          this.imageUrl = this.downloadUrl;
        }
        let file: any = {};
        file.url = this.downloadUrl;
        file.type = type;
        this.getPrescriptionUrl.emit(file);
        console.log("File Upload Complete: ", file); 
        this.cd.markForCheck();
        loading.dismiss();
      })
    });
    this.snapshot   = this.task.snapshotChanges();
    this.progress = this.task.percentageChanges();
  }

  public presentActionSheet() {
    let actionSheet = this.actionSheetCtrl.create({
      title: "Select Image Source",
      buttons: [
        {
          text: "Load from Photo Library",
          handler: () => {
            this.addImageToArray(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        },
        {
          text: "Use Camera",
          handler: () => {
            this.addImageToArray(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: "Cancel",
          role: "cancel"
        }
      ]
    });
    actionSheet.present();
  }

  async addImageToArray(type)  {
    await this.captureImage(type).then((image) => {
      if(image) {
        this.mobileimages.push('data:image/jpeg;base64,' + image);
        this.cd.markForCheck();
      }
    });
  }

  async getImageFromDevice(sourceType) {
    console.log("Upload Patient: ", this.patient)
    console.log("Upload Doctor: ", this.doctor)
    const imagestring = await this.captureImage(sourceType);
    const loading = this.loadingCtrl.create({});
    loading.present();
    const base64 = "data:image/jpeg;base64," + imagestring;
    console.log("Image Captured: ", base64)
    var date = new Date();
    let imageText = this.clinic_name;
    if(this.doctor) imageText += " - Dr. " + this.doctor.first_name + " " + this.doctor.last_name + " - ";
    else imageText += " - ";
    imageText += date.toLocaleDateString() + " " + date.toLocaleTimeString();

    this.image.addTextToImage(base64, imageText).then(img => {
      console.log(imageText)
      console.log(img)
      loading.dismiss().then(() => {
        this.createUploadTask(img, "jpg");
        this.cd.markForCheck();
      });
    });
  }

  private uploadMobileFiles() {
    //  Process Single Upload
    if (this.mobileimages.length === 1) { 
      const loading = this.loadingCtrl.create({});
      loading.present();
      const base64 = this.mobileimages[0];
      console.log("Image Captured: ", base64)
      var date = new Date();
      let imageText = this.clinic_name;
      if(this.doctor) imageText += " - Dr. " + this.doctor.first_name + " " + this.doctor.last_name + " - ";
      else imageText += " - ";
      imageText += date.toLocaleDateString() + " " + date.toLocaleTimeString();
  
      this.image.addTextToImage(base64, imageText).then(img => {
        console.log(imageText)
        console.log(img)
        loading.dismiss().then(() => {
          this.createUploadTask(img, "jpg");
          this.cd.markForCheck();
        });
      });
    }
    // Process Multiple Images
    else {
      const loading = this.loadingCtrl.create({});
      loading.present();
      this.createPDF(this.mobileimages).then((doc) => {
        this.image.getBase64(doc).then((pdf: string) => {
          this.createUploadTask(pdf, "pdf");
          loading.dismiss();
        });
      })
    }
  }

  public uploadDesktopFiles(files: FileList) {
    //  Process Single Upload
    if (files.length === 1) { 
      const loading = this.loadingCtrl.create({});
      loading.present();
      this.image.getBase64(files.item(0)).then((b64Image: string) => {
        console.log(b64Image);
        if (files.item(0).type === "application/pdf") {
          loading.dismiss().then(() => {
            this.createUploadTask(b64Image, "pdf");
          });
        } else {
          var date = new Date();
          let imageText = this.clinic_name;
          if(this.doctor) imageText += " - Dr. " + this.doctor.first_name + " " + this.doctor.last_name + " - ";
          else imageText += " - ";
          imageText += date.toLocaleDateString() + " " + date.toLocaleTimeString();
          console.log("Add Text: ", imageText)
          this.image.addTextToImage(b64Image, imageText).then(img => {
            loading.dismiss().then(() => {
              this.createUploadTask(img, "jpg");
            });
          });
        }
      });
    }
    // Process Multiple Images
    else {
      // Multiple PDFs are not supported
      let filetype: any = files.item(0).type.split('/')[1].replace(' ','');
      if(filetype === 'pdf')  {
        let alert = this.alertCtrl.create({
          title: "PDF  Problem",
          subTitle: "You may only upload a single PDF.  If you need to upload multiple prescriptions as PDFs, please use a multipage PDF document",
          buttons: ["OK"]
        });
        alert.present();
        return;
      }
      // Process multiple images
      else {
        let images = [];
        const loading = this.loadingCtrl.create({});
        loading.present();
        this.doImages(Array.from(files)).then((images) => {
          this.createPDF(images).then((doc) => {
            this.image.getBase64(doc).then((pdf: string) => {
              this.createUploadTask(pdf, "pdf");
              loading.dismiss();
              this.mobileimages = [];
            });
          })
        })
   

        // this.image.getBase64(files.item(0)).then((b64Image: string) => {
        //   console.log(b64Image);
        //   if (files.item(0).type === "application/pdf") {
        //     loading.dismiss().then(() => {
        //       this.createUploadTask(b64Image, "pdf");
        //     });
        //   } else {
        //     var date = new Date();
        //     let imageText = this.clinic_name;
        //     if(this.doctor) imageText += " - Dr. " + this.doctor.first_name + " " + this.doctor.last_name + " - ";
        //     else imageText += " - ";
        //     imageText += date.toLocaleDateString() + " " + date.toLocaleTimeString();
        //     console.log("Add Text: ", imageText)
        //     this.image.addTextToImage(b64Image, imageText).then(img => {
        //       loading.dismiss().then(() => {
        //         this.createUploadTask(img, "jpg");
        //       });
        //     });
        //   }
        // });
      }
    }
  }

  async doImages (files) {
    let i = [];
    await files.reduce(async (promise, file) => {
      // This line will wait for the last async function to finish.
      // The first iteration uses an already resolved Promise
      // so, it will immediately continue.
      await promise;
      this.image.getBase64(file).then((image) => {
        i.push(image)
      });
    }, Promise.resolve());
    return i;
  }

  createPDF(k) {
    var date = new Date();
    let imageText = this.clinic_name;
    if(this.doctor) imageText += " - Dr. " + this.doctor.first_name + " " + this.doctor.last_name + " - ";
    else imageText += " - ";
    imageText += date.toLocaleDateString() + " " + date.toLocaleTimeString();
    console.log("Add Text: ", imageText)

    return new Promise (function (resolve, reject) {
      console.log('create these images: ', k);
      setTimeout(()=>{
        let doc = new jsPDF('p', 'px', 'letter');
        doc.deletePage(1);
        k.forEach(async r => {
          doc.addPage();
          doc.text(imageText, 10, 10);
          let width = doc.internal.pageSize.getWidth();
          let height = doc.internal.pageSize.getHeight();
          doc.addImage(r, 20, 20, width-40, height-40);
        })
        resolve(doc.output('blob'));
      }, 1000);
    });
  }

  getImageDimensions(file) {
    return new Promise (function (resolved, rejected) {
      var i = new Image()
      i.onload = function(){
        resolved({w: i.width, h: i.height})
      };
      i.src = file
    })
  }

    // Determines if the upload task is active
    isActive(snapshot) {
      return snapshot.state === 'running' && snapshot.bytesTransferred < snapshot.totalBytes
    }

    toggleHover(event: boolean) {
      this.isHovering = event;
    }

  openPDF(url)  {
    this.iab.create(url, '_blank')
  }

  deleteImage(image)  {
    let index = this.mobileimages.indexOf(image);
    
        if (index > -1) {
          this.mobileimages.splice(index, 1);
        }
  }
}



// WEBPACK FOOTER //
// ./src/components/upload-prescription/upload-prescription.ts